module.exports = __webpack_public_path__ + "static/media/DR_bg_clear.6d887300.bmp";